import { createStore } from "vuex";
import auth from "./modules/auth";
import permission from "./modules/permission";

export default createStore({
  state: {
    ifDetailVisible: true,
    idForDetailCard: "",
    typeForDetailCard: "",
  },
  mutations: {
    handleDetailShow(state) {
      state.ifDetailVisible = true;
    },
    handleDetailDisappear(state) {
      state.ifDetailVisible = false;
    },
    handleIdForDetailCardChange(state, newId) {
      state.idForDetailCard = newId;
    },
    handletTypeForDetailCardChange(state, newType) {
      state.typeForDetailCard = newType;
    },
  },
  actions: {},
  modules: {
    auth,
    permission,
  },
});
